import { render } from "./serialnoexport.vue?vue&type=template&id=0b81b272"
import script from "./serialnoexport.vue?vue&type=script&lang=js"
export * from "./serialnoexport.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__